import { CommonModule } from '@angular/common';
import { Component, input, model, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-approve-confirm-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, MessageModule],
  templateUrl: './approve-confirm-dialog.html',
  styleUrl: './approve-confirm-dialog.scss'
})
export class ApproveConfirmDialog {
  readonly visible = model<boolean>(false);
  readonly entreeName = input<string>('');
  readonly submitting = input<boolean>(false);

  /** Something the approver should know that does not stop them approving. Null when there is nothing to say. */
  readonly warning = input<string | null>(null);

  readonly approve = output<void>();
  readonly cancel = output<void>();

  onApprove(): void {
    this.approve.emit();
  }

  onCancel(): void {
    this.cancel.emit();
    this.visible.set(false);
  }

  onVisibleChange(value: boolean): void {
    if (!value) {
      this.cancel.emit();
    }
    this.visible.set(value);
  }
}
